import type { TGetInfoAboutHostingResponse } from '@eway-crm/hostingdaemon-js-lib';
import Connection from '../api/Connection';
import SearchParams from '../constants/SearchParams';
import { OUTLOOK_GUID_NAME_MAP } from '../pages/CompanyInfoPage/data/getCompanyInfoTwoDropdownOptions';
import type { TUserToCreate } from '../pages/FinalizationPage/Finalization/Finalization';
import { compare } from 'compare-versions';
import EnvironmentHelper from './EnvironmentHelper';

const RedirectToImportContactsFromO365Page = (hostingInfo: TGetInfoAboutHostingResponse, accountsInfo: TUserToCreate[], outlookType: string[], isLoggedViaMs: boolean, wcfVersion: string | undefined, language: string, failedCallback: () => void) => {
    const welcomePageUrl = `${hostingInfo.eWayWebServiceUrl}/Web/#/welcome-page`;
    const { username } = accountsInfo[0];

    const appOrigin = "https://app.eway-crm." + (EnvironmentHelper.isProd() ? "com" : "dev");

    const getOutlookTypeParamValue = () => {
        return encodeURIComponent(outlookType.map(ot => OUTLOOK_GUID_NAME_MAP[ot]).join(","));
    };

    const additionalUrlParams = `${SearchParams.outlookTypes}=${getOutlookTypeParamValue()}&lang=${language}&${SearchParams.isAzureLogin}=${isLoggedViaMs ? '1' : '0'}`;
    const appWelcomePath = '/welcome-page?' + additionalUrlParams;

    if (isLoggedViaMs) {
        const baseUrl = appOrigin + "/auth/";
        let url = `${baseUrl}?phase=login&client_id=web%20access&username=${username}&redirect=${encodeURIComponent(appWelcomePath)}`;
        url += "&wsurl=" + encodeURIComponent(hostingInfo.eWayWebServiceUrl);
        window.location.replace(url);
    }
    else {
        // Create session and pass session id
        const { password } = accountsInfo[0];
        Connection.GetNewSessionId(hostingInfo.eWayWebServiceUrl, username, password!, hostingInfo.eWayClientVersion, (sessionId) => {
            if (sessionId) {
                if (wcfVersion && compare(wcfVersion, "10.0.0.73", ">=")) {
                    // Newer webservices with the special signup identity endpoint
                    const signinUrl = `${hostingInfo.eWayWebServiceUrl}/auth/signup/session`;
                    const signinPostData = {
                        sessionId,
                        redirectUrl: `${appOrigin}/#${appWelcomePath}&wsUrl=${encodeURIComponent(hostingInfo.eWayWebServiceUrl)}`,
                    };

                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = signinUrl;

                    Object.entries(signinPostData).forEach(([name, value]) => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                } else {
                    // Older webservices without the special signup identity endpoint

                    window.location.replace(`${welcomePageUrl}?sessionId=${sessionId}&${additionalUrlParams}&wsUrl=${encodeURIComponent(hostingInfo.eWayWebServiceUrl)}`);
                }
            }
            else {
                failedCallback();
            }
        });
    }
};

export default RedirectToImportContactsFromO365Page;
